import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { AppShellSkeleton } from "../../components/layout/app-shell-skeleton";
import { isPlatformPath, LOGIN_PATH, SYSTEM_ADMIN_LOGIN_PATH } from "../../lib/sign-in-paths";
import { useAuthStore } from "../../stores/auth-store";

export const CHANGE_PASSWORD_PATH = "/change-password";

/**
 * Shows children only to signed-in people; everyone else goes to the sign-in page: the platform
 * console's to Eduleo's team sign-in, everything else to the school sign-in. People still on a
 * password someone else set go to choose their own first, then come back here.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);
  const mustChangePassword = useAuthStore((state) => state.user?.mustChangePassword === true);
  const location = useLocation();
  const here = `${location.pathname}${location.search}`;

  // Restoring the session: the app's frame with placeholders, not a blank page.
  if (status === "loading") return <AppShellSkeleton />;
  if (status === "signed_out") {
    const signIn = isPlatformPath(location.pathname) ? SYSTEM_ADMIN_LOGIN_PATH : LOGIN_PATH;
    return <Navigate to={signIn} replace state={{ from: here }} />;
  }
  if (mustChangePassword) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace state={{ from: here, forced: true }} />;
  }
  return children;
}
